import { emitterCreateSubscriber } from '@THC/utils/emitter';

import { ErrorInfoboxEmitter } from './ErrorInfoboxEmitter';

const subscribe = emitterCreateSubscriber(ErrorInfoboxEmitter);

export const subscribeErrorInfoboxSetEvent = subscribe('set');

export const debugErrorInfoboxEvents = subscribe('*');
